import { unwrapResult } from '@reduxjs/toolkit'
import invoiceApi from 'api/invoiceApi'
import { setAppSpinning } from 'app/appSlice'
import dayjs from 'dayjs'
import {
  thunkGetGoodsGroupList,
  thunkGetGoodsList,
  thunkGetMoneyTypeList,
} from 'features/Category/categorySlice'
import { useFormik } from 'formik'
import InvoiceFooter from 'general/components/eInvoiceComponents/AppFooter/InvoiceFooter'
import AddCustomFieldModal from 'general/components/Modal/AddCustomFieldModal'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import SendInvoiceModal from 'general/components/Modal/SendInvoiceModal'
import SelectOptions from 'general/constants/SelectOptions'
import ToastHelper from 'general/helpers/ToastHelper'
import Global from 'general/utils/Global'
import Utils, {
  findObjectInArray,
  formatNumberData,
  getParam,
  regexTaxCode,
  setTaxCode,
} from 'general/utils/Utils'
// import moment from 'moment';
import IssueInvoiceFromPosModal from 'general/components/Modal/IssueInvoiceFromPosModal'
import {
  ACTION_TYPE,
  INVOICE_TYPE,
  PRODUCT_PROPERTY,
} from 'general/constants/AppConstants'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import FinalMoneyDisplay from './Components/FinalMoneyDisplay'
import InvoiceGeneralInfo from './Components/InvoiceGeneralInfo'
import DeliveryGeneralInfo from './Components/DeliveryGeneralInfo'
import InvoiceTableGeneralInfo from './Components/InvoiceTableGeneralInfo'
import SelectGeneralDiscountAndTaxRate from './Components/SelectGeneralDiscountAndTaxRate'
import CreatedInvoiceUnit from './Components/TreeSelect/CreatedInvoiceUnit'
import createNewInvoice from './Function/CreateNewInvoice'
import updateInvoice from './Function/UpdateInvoice'
import './style.scss'
import TableHospitalInfo from './Components/TableHospitalInfo'
import { useParams } from 'react-router-dom'
import useInvoiceActions from './hooks/useInvoiceActions'
import { useInvoiceCalculations } from './hooks/useInvoiceCalculation'
import { useFetchInvoice } from './hooks/useFetchInvoice'
import { Table } from 'antd'
import { getColumns } from './Function/column'
import {
  REGEX_BUDGET_UNIT_CODE,
  REGEX_CMND_CCCD,
  REGEX_IDENTIFY,
} from 'general/constants/AppRegex'
import Swal from 'sweetalert2'

var submitAction
function CreateInvoice() {
  const { currentAccount } = useAppSelector((state) => state?.auth)
  const { company } = useAppSelector((state) => state.system)
  const { formatNumber, currency, VATConfig, invoiceSetting } = useAppSelector(
    (state) => state?.systemConfig,
  )
  const moneyTypes = useAppSelector((state) => state?.category?.moneyTypes)

  const { navigate, query, pathname } = useRouter()
  const { invoiceInfo } = useParams()
  const dispatch = useAppDispatch()
  const invoiceFooterRef = useRef(null)

  const partsName = pathname.split('/')

  const [invoiceType, setInvoiceType] = useState()
  const [buyerInfoExtendFields, setBuyerInfoExtendFields] = useState([])
  const [tableDetailExtendFields, setTableDetailExtendFields] = useState([])
  const [templateInvoiceSerials, setTemplateInvoiceSerials] = useState([])
  const [currencies, setCurrencies] = useState([...SelectOptions.currencyNew])
  const [discountTypeArray, setDiscountTypeArray] = useState(
    SelectOptions.discountType,
  )
  const [fetchedInvoiceInfo, setFetchedInvoiceInfo] = useState({})
  const [latestInvoice, setLatestInvoice] = useState()
  const [latestInvoiceTemplate, setLatestInvoiceTemplate] = useState()
  const [invoiceTemplateDetail, setInvoiceTemplateDetail] = useState()
  const [createdInvoiceId, setCreatedInvoiceId] = useState()

  const [sendDraftInvoiceModalShow, setSendDraftInvoiceModalShow] =
    useState(false)
  const [AddCustomFieldModalShow, setAddCustomFieldModalShow] = useState(false)
  const [
    showModalConfirmSaveToSendInvoice,
    setShowModalConfirmSaveToSendInvoice,
  ] = useState(false)
  const [showModalConfirmDuplicateName, setShowModalConfirmDuplicateName] =
    useState(false)
  const [checkedHHDV, setCheckedHHDV] = useState(false)
  const [invoiceData, setInvoiceData] = useState(true)
  const [persistent, setPersistent] = useState('quantityPersistent')
  const [inputValue, setInputValue] = useState('')
  const [isChangeTaxRate, setIsChangeTaxRate] = useState(false)
  const [isChangeTable, setIsChangeTable] = useState(false)
  const [invoiceTemplateIdNewYear, setInvoiceTemplateIdNewYear] = useState({})
  const [rowHeight, setRowHeight] = useState()
  const [issueInvoiceFromPosModalInfo, setIssueInvoiceFromPosModalInfo] =
    useState({
      show: false,
      invoiceId: null,
    })
  const [inforActionSaveAndSign, setInforActionSaveAndSign] = useState({
    disabled: false,
  })

  const [actionType] = useState(() => {
    if (partsName.includes('them-moi')) return ACTION_TYPE.CREATE
    if (
      partsName.includes('dieu-chinh') ||
      partsName.includes('dieu-chinh-khac-he-thong')
    )
      return ACTION_TYPE.ADJUST
    if (
      partsName.includes('thay-the') ||
      partsName.includes('thay-the-khac-he-thong')
    )
      return ACTION_TYPE.REPLACE
    if (partsName.includes('cap-nhat')) return ACTION_TYPE.UPDATE
    return ''
  })

  const [invoiceExtendFields, setInvoiceExtendFields] = useState([])

  const systemTaxRate = useMemo(() => {
    return VATConfig?.value?.replace('%', '') ?? '0'
  }, [VATConfig])

  // Derived States
  const isFromPOS = useMemo(
    () =>
      pathname.includes('may-tinh-tien') ||
      pathname.includes('taxAuthorityCode=M'), // Khi đó là hóa đơn MTT từ hệ thông khác
    [pathname],
  )

  const isDeliveryBill = useMemo(
    () => pathname.includes('phieu-xuat-kho'),
    [pathname],
  )
  const redirectUrl = useMemo(() => {
    if (isFromPOS)
      return '/hoa-don-dau-ra/hoa-don/may-tinh-tien/danh-sach-hoa-don'
    if (isDeliveryBill) return '/hoa-don-dau-ra/hoa-don/phieu-xuat-kho'
    return '/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don'
  }, [isFromPOS, isDeliveryBill])

  const showPriceAfterTax = invoiceSetting?.priceAfterTax
  const { invoiceId } = query

  const checkIsAdjustInvoice = (type) => {
    return (
      partsName.includes('dieu-chinh') ||
      partsName.includes('dieu-chinh-khac-he-thong') ||
      (partsName.includes('cap-nhat') && type === INVOICE_TYPE.ADJUST)
    )
  }
  const today = new Date()
  const invoiceTemplate = useMemo(() => {
    // console.log(
    //   'invoiceTemplatekiiiiiiiiiiiiiiiiiiiiiiii',
    //   templateInvoiceSerials,
    // )
    // console.log('invoiceTemplatekiaaaaaaaaaaaaaaaaaaaaaaaa', latestInvoice)
    if (latestInvoice) {
      const yearNow = dayjs().year() % 100
      let serialInvoice = latestInvoice?.serial?.slice(2, 4)
      let checkSerial = serialInvoice == yearNow
      if (checkSerial) {
        return templateInvoiceSerials?.find(
          ({ invoiceTemplateId }) =>
            invoiceTemplateId == latestInvoice.invoiceTemplateId,
        )
      } else {
        // Trường hợp năm mới
        let serialInvoiceNew = (
          !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
        )?.serial?.replace(serialInvoice, yearNow)
        return templateInvoiceSerials?.find(
          ({ serial }) => serial == serialInvoiceNew,
        )
      }
    }
    if (!fetchedInvoiceInfo.invoiceTemplateId)
      return templateInvoiceSerials?.at(0)

    return templateInvoiceSerials?.find(
      ({ invoiceTemplateId }) =>
        invoiceTemplateId == fetchedInvoiceInfo.invoiceTemplateId,
    )
  }, [templateInvoiceSerials, fetchedInvoiceInfo, latestInvoice])

  const getInvoiceTemplace = (
    fetchedInvoiceInfoT,
    invoiceId,
    latestInvoice,
  ) => {
    const yearCurrentInvoiceTemplate = fetchedInvoiceInfoT?.serial?.substring(
      2,
      4,
    )
    const yearNow = dayjs().year() % 100
    if (yearNow != yearCurrentInvoiceTemplate) {
      const serialNew = fetchedInvoiceInfoT?.serial?.replace(
        yearCurrentInvoiceTemplate,
        yearNow,
      )
      let dataInvoice = findObjectInArray(
        templateInvoiceSerials,
        'serial',
        serialNew,
      )
      if (dataInvoice) {
        return dataInvoice
      } else {
        let serialInvoice = (
          !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
        )?.serial?.slice(2, 4)
        let checkSerial = serialInvoice == yearNow

        let serialInvoiceNew = (
          !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
        )?.serial?.replace(serialInvoice, yearNow)
        let dataInvoiceTemplate = findObjectInArray(
          templateInvoiceSerials,
          'serial',
          serialInvoiceNew,
        )
        if (!dataInvoiceTemplate) {
          dataInvoiceTemplate = templateInvoiceSerials[0]
        }
        // console.log('serialInvoiceNew', serialInvoiceNew)
        // console.log('templateInvoiceSerials', templateInvoiceSerials)
        return !Utils.isObjectNull(invoiceId)
          ? invoiceTemplate
            ? invoiceTemplate
            : {
                serial: templateInvoiceSerials?.[0]?.label,
                invoiceTemplateId: templateInvoiceSerials?.[0]?.value,
              }
          : checkSerial
            ? latestInvoice
            : {
                ...latestInvoice,
                serial: dataInvoiceTemplate?.label,
                invoiceTemplateId: dataInvoiceTemplate?.value,
              }
      }
    } else {
      return !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
    }
  }

  const getTemplate = (fetchedInvoiceInfoT) => {
    const yearCurrentInvoiceTemplate = fetchedInvoiceInfoT?.serial?.substring(
      2,
      4,
    )
    const yearNow = dayjs().year() % 100
    if (yearNow != yearCurrentInvoiceTemplate) {
      const serialNew = fetchedInvoiceInfoT?.serial?.replace(
        yearCurrentInvoiceTemplate,
        yearNow,
      )
      let dataInvoice = findObjectInArray(
        templateInvoiceSerials,
        'serial',
        serialNew,
      )
      if (dataInvoice) {
        return dataInvoice
      } else {
        let serialInvoice = (
          !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
        )?.serial?.slice(2, 4)
        let checkSerial = serialInvoice == yearNow
        let serialInvoiceNew = (
          !Utils.isObjectNull(invoiceId) ? invoiceTemplate : latestInvoice
        )?.serial?.replace(serialInvoice, yearNow)
        let dataInvoiceTemplate = findObjectInArray(
          templateInvoiceSerials,
          'serial',
          serialInvoiceNew,
        )
        if (!dataInvoiceTemplate) {
          dataInvoiceTemplate = templateInvoiceSerials[0]
        }
        return invoiceTemplate
          ? invoiceTemplate
          : !checkSerial
            ? dataInvoiceTemplate
            : templateInvoiceSerials?.[0]
      }
    } else {
      return invoiceTemplate
    }
  }

  // lưu invoiceTemplate
  const [currentTemplate, setCurrentTemplate] = useState(invoiceTemplate)

  const [tableData, setTableData] = useState([
    {
      no: 1,
      type: latestInvoiceTemplate?.isDeliveryBill
        ? PRODUCT_PROPERTY.SPECIAL_GOODS
        : invoiceTemplate?.isDeliveryInvoice
          ? PRODUCT_PROPERTY.SPECIAL_GOODS
          : PRODUCT_PROPERTY.GOODS_SERVICE,
      name: '',
      specification: '',
      inventoryItemCode: '',
      actualExport: 0,
      actualImport: 0,
      unit: '',
      unitPrice: 0,
      quantity: 0,
      discount: 0,
      totalUnitPrice: 0,
      unitPriceAfterTax: 0,
      totalUnitPriceAfterTax: 0,
      taxRate: systemTaxRate ?? '0',
      taxReduction: 0,
      taxReductionExchange: 0,
      taxReductionRate: 0,
      taxMoney: 0,
      discountMoney: 0,
      productId: 0,
      exchangeRate: 1,
      exchangedTotalUnitPriceAfterTax: 0,
      exchangedTotalUnitPrice: 0,
      exchangedTaxMoney: 0,
      exchangedDiscountMoney: 0,
    },
  ])

  // set tableData based on invoiceTemplate
  const [isInitialized, setIsInitialized] = useState(false)
  useEffect(() => {
    if (!isInitialized && invoiceTemplate) {
      setTableData((prev) => {
        return prev.map((item) => ({
          ...item,
          type:
            (invoiceTemplate?.isDeliveryInvoice ||
              invoiceTemplate?.category?.code === 'BX') &&
            actionType === ACTION_TYPE.CREATE &&
            !item.type
              ? PRODUCT_PROPERTY.SPECIAL_GOODS
              : item.type,
          plateNumber:
            invoiceTemplate?.isDeliveryInvoice && !item.plateNumber
              ? ''
              : item.plateNumber,
        }))
      })
      setIsInitialized(true)
      setCurrentTemplate(invoiceTemplate)
      // Hiển thị tính chất HHDV
      if (
        invoiceTemplate?.isDeliveryInvoice ||
        invoiceTemplate?.category?.code === 'BX'
      ) {
        setCheckedHHDV(true)
      }
    }
  }, [actionType, invoiceTemplate, isInitialized])

  const handle_warning_total = async () => {
    return await Swal.fire({
      title: 'Cảnh báo',
      html: `
      Tổng tiền trên hóa đơn bằng <b>0</b>,
      nếu số liệu đúng chọn tiếp tục.`,

      icon: 'warning',

      showCancelButton: true,

      confirmButtonText: 'Tiếp tục',

      cancelButtonText: 'Kiểm tra lại',

      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',

        cancelButton: 'btn btn-light font-weight-bolder',
      },
    })
  }

  const formik = useFormik({
    initialValues: {
      // invoiceId: '',
      serial: getInvoiceTemplace(fetchedInvoiceInfo, invoiceId, latestInvoice)
        ?.serial,
      invoiceTemplateId: getInvoiceTemplace(
        fetchedInvoiceInfo,
        invoiceId,
        latestInvoice,
      )?.invoiceTemplateId,
      invoiceTemplateName: getTemplate(fetchedInvoiceInfo, invoiceTemplate)
        ?.name,
      type:
        partsName.includes('them-moi') ||
        (partsName.includes('dieu-chinh') && !getParam('viewInvoiceProduct'))
          ? 0
          : fetchedInvoiceInfo?.type,
      taxType: getTemplate(fetchedInvoiceInfo, invoiceTemplate)?.category
        ?.taxType,
      currency: fetchedInvoiceInfo?.currency ?? 'VNĐ',
      exchangeRate: fetchedInvoiceInfo?.exchangeRate ?? 1,
      date: Utils.formatDate(
        actionType === ACTION_TYPE.UPDATE ? fetchedInvoiceInfo?.date : today,
      ),
      sellerName: fetchedInvoiceInfo?.sellerName ?? company?.companyName,
      sellerTaxCode: setTaxCode(
        fetchedInvoiceInfo?.sellerTaxCode ?? company?.taxCode,
        company,
      ),
      sellerFullAddress:
        fetchedInvoiceInfo?.sellerFullAddress ?? company?.businessPermitAddress,
      sellerPhone: fetchedInvoiceInfo?.sellerPhone ?? currentAccount?.phone,
      sellerEmail: fetchedInvoiceInfo?.sellerEmail ?? currentAccount?.email,
      sellerAccountNumber:
        fetchedInvoiceInfo?.sellerAccountNumber ?? company?.bankAccountNumber,
      sellerBankName: fetchedInvoiceInfo?.sellerBankName ?? company.bankName,
      sellerFax: fetchedInvoiceInfo?.sellerFax ?? company?.fax,
      sellerWebsite: fetchedInvoiceInfo?.sellerWebsite ?? company?.website,
      customerCompanyName: fetchedInvoiceInfo?.customerCompanyName ?? '',
      customerName: fetchedInvoiceInfo?.customerName ?? '',
      customerTaxCode: fetchedInvoiceInfo?.customerTaxCode ?? '',
      customerId: fetchedInvoiceInfo?.customerId ?? '',
      customerFullAddress: fetchedInvoiceInfo?.customerFullAddress ?? '',
      customerPhone: fetchedInvoiceInfo?.customerPhone ?? '',
      customerEmail: fetchedInvoiceInfo?.customerEmail ?? '',
      customerPassportNumber: fetchedInvoiceInfo?.customerPassportNumber ?? '',
      budgetUnitCode: fetchedInvoiceInfo?.budgetUnitCode ?? '',
      department: fetchedInvoiceInfo?.department ?? '',
      patientCode: fetchedInvoiceInfo?.patientCode ?? '',
      doctor: fetchedInvoiceInfo?.doctor ?? '',
      customerAccountNumber: fetchedInvoiceInfo?.customerAccountNumber ?? '',
      customerBankName: fetchedInvoiceInfo?.customerBankName ?? '',

      customerPersonalIdentificationNumber:
        fetchedInvoiceInfo?.customerPersonalIdentificationNumber ?? '',

      taxRate: fetchedInvoiceInfo?.taxRate ?? systemTaxRate ?? '0',
      total:
        actionType === ACTION_TYPE.ADJUST
          ? 0
          : (fetchedInvoiceInfo?.total ?? 0),
      taxMoney:
        actionType === ACTION_TYPE.ADJUST
          ? 0
          : (fetchedInvoiceInfo?.taxMoney ?? 0),
      totalAfterTax:
        actionType === ACTION_TYPE.ADJUST
          ? 0
          : fetchedInvoiceInfo?.totalAfterTax
            ? fetchedInvoiceInfo?.totalAfterTax
            : 0,
      totalAfterTaxVnese:
        actionType === ACTION_TYPE.ADJUST
          ? ''
          : (fetchedInvoiceInfo?.totalAfterTaxVnese ?? 'Không đồng'),
      discountType: fetchedInvoiceInfo?.discountType ?? 0,
      discountMoney:
        actionType === ACTION_TYPE.ADJUST
          ? 0
          : (fetchedInvoiceInfo?.discountMoney ?? 0),
      discount: fetchedInvoiceInfo?.discount ?? null, // % chiết khấu
      isSent: 0,
      isPayment:
        actionType === ACTION_TYPE.UPDATE
          ? fetchedInvoiceInfo?.isPayment
          : false,
      // : fetchedInvoiceInfo?.isPayment ?? false,
      isTaxReduction: fetchedInvoiceInfo?.isTaxReduction ?? false,
      description: fetchedInvoiceInfo?.description ?? '',
      paymentMethod: fetchedInvoiceInfo?.paymentMethod ?? 1,
      exchangedTotalUnitPriceAfterTax: 0,
      exchangedTotal:
        partsName.includes('them-moi') ||
        (partsName.includes('dieu-chinh') && !getParam('viewInvoiceProduct'))
          ? 0
          : (fetchedInvoiceInfo?.exchangedTotal ?? 0),
      exchangedTaxMoney:
        partsName.includes('them-moi') ||
        (partsName.includes('dieu-chinh') && !getParam('viewInvoiceProduct'))
          ? 0
          : (fetchedInvoiceInfo?.exchangedTaxMoney ?? 0),
      exchangedDiscountMoney:
        (fetchedInvoiceInfo?.discountMoney ?? 0) *
        (fetchedInvoiceInfo?.exchangeRate ?? 0),
      multipleTaxRate:
        fetchedInvoiceInfo?.multipleTaxRate ??
        invoiceTemplate?.category?.taxType === 2,
      // invoiceTemplate?.category?.taxType > 1,
      companyUnitId: fetchedInvoiceInfo?.companyUnitId,
      extendFields: {},

      // Bệnh viện
      advanceAmount:
        fetchedInvoiceInfo?.advanceAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      patientExemptedAmount:
        fetchedInvoiceInfo?.patientExemptedAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      hospitalReturnAmount:
        fetchedInvoiceInfo?.hospitalReturnAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      patientPaidAdditionalAmount:
        fetchedInvoiceInfo?.patientPaidAdditionalAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),

      totalPayableAmount:
        fetchedInvoiceInfo?.totalPayableAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      healthInsuranceCoveredAmount:
        fetchedInvoiceInfo?.healthInsuranceCoveredAmount ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      coronavirusPcrTestCost:
        fetchedInvoiceInfo?.coronavirusPcrTestCost ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),
      covid19TreatmentCost:
        fetchedInvoiceInfo?.covid19TreatmentCost ??
        ((invoiceTemplate ?? latestInvoiceTemplate)?.category?.code == 'BV'
          ? 0
          : ''),

      // end Bệnh viện
      // tự động tính số liệu điều chỉnh
      autoCalculate:
        // Nếu hóa đơn đã có giá trị và sau đó chọn điều chỉnh thì là false
        fetchedInvoiceInfo?.autoCalculate && checkIsAdjustInvoice()
          ? false
          : // nkhi thêm mới thì mặc định là true
            (fetchedInvoiceInfo?.autoCalculate ?? true),
      // !checkIsAdjustInvoice() || fetchedInvoiceInfo?.autoCalculate,
      // thành tiền quy đổi
      exchangedTotalAfterTax: fetchedInvoiceInfo?.exchangedTotalAfterTax ?? 0,
      // Phiếu xuất kho
      buyerName: fetchedInvoiceInfo?.buyerName ?? '',
      invoiceNote: fetchedInvoiceInfo?.invoiceNote ?? '',
      deliveryBy: fetchedInvoiceInfo?.deliveryBy ?? '',
      deliveryOrderBy: fetchedInvoiceInfo?.deliveryOrderBy ?? '',
      buyerTaxCode: fetchedInvoiceInfo?.buyerTaxCode ?? '',
      containerNumber: fetchedInvoiceInfo?.containerNumber ?? '',
      transportationMethod: fetchedInvoiceInfo?.transportationMethod ?? '',
      stockOutFullName: fetchedInvoiceInfo?.stockOutFullName ?? '',
      stockInFullName: fetchedInvoiceInfo?.stockInFullName ?? '',
      fromWarehouseName: fetchedInvoiceInfo?.fromWarehouseName ?? '',
      toWarehouseName: fetchedInvoiceInfo?.toWarehouseName ?? '',
      deliveryOrderDate: fetchedInvoiceInfo?.deliveryOrderDate
        ? dayjs(fetchedInvoiceInfo?.deliveryOrderDate)
        : null,
      // nội bộ
      exporterName: fetchedInvoiceInfo?.exporterName ?? '',
      consigneeUnitName: fetchedInvoiceInfo?.consigneeUnitName ?? '',
      consigneeUnitTaxcode: fetchedInvoiceInfo?.consigneeUnitTaxcode ?? '',
      consigneeUnitAddress: fetchedInvoiceInfo?.consigneeUnitAddress ?? '',
      importerName: fetchedInvoiceInfo?.importerName ?? '',
      invoiceType,
      //dùng cờ đánh dấu đã update
      startFormData: 0,
      addressWarehouse:
        fetchedInvoiceInfo?.sellerFullAddress ?? company?.businessPermitAddress,
      //thông tin hóa đơn tai sản công
      ...(getInvoiceTemplace(
        fetchedInvoiceInfo,
        invoiceId,
        latestInvoice,
      )?.serial?.slice(0, 1) == 3
        ? {
            saleDecisionNo: fetchedInvoiceInfo?.saleDecisionNo ?? null,
            dateSaleDecisionNo: fetchedInvoiceInfo?.dateSaleDecisionNo
              ? dayjs(fetchedInvoiceInfo?.dateSaleDecisionNo)
              : null,
            decisionIssuingAgency:
              fetchedInvoiceInfo?.decisionIssuingAgency ?? null,
            saleMethod: fetchedInvoiceInfo?.saleMethod ?? null,
            buyerAddressTransport:
              fetchedInvoiceInfo?.buyerAddressTransport ?? null,
            buyerStartTimeTransport: fetchedInvoiceInfo?.buyerStartTimeTransport
              ? dayjs(fetchedInvoiceInfo?.buyerStartTimeTransport)
              : null,
            buyerEndTimeTransport: fetchedInvoiceInfo?.buyerEndTimeTransport
              ? dayjs(fetchedInvoiceInfo?.buyerEndTimeTransport)
              : null,
          }
        : {}),
      taxReduction: fetchedInvoiceInfo?.taxReduction ?? 0,
      exchangedTotalTaxReduction:
        fetchedInvoiceInfo?.exchangedTotalTaxReduction ?? 0,
    },
    // validationSchema: Yup.object({
    //   buyerName: Yup.string().required('Nhập đi!'),
    // }),
    onSubmit: async (values) => {
      console.log('values', values)
      const parseNumber = (str) => {
        return Number(str.replace(/,/g, ''))
      }
      if (values?.discountMoney && typeof values?.discountMoney === 'string') {
        let checkNaN = Number(
          values.discountMoney?.replaceAll('.', '')?.replace(',', '.'),
        )
        if (Number.isNaN(checkNaN)) {
          values.discountMoney = parseNumber(values.discountMoney)
        } else {
          values.discountMoney = checkNaN
        }
      }

      if (values?.taxReduction && typeof values?.taxReduction === 'string') {
        let checkNaN = Number(
          values.taxReduction?.replaceAll('.', '')?.replace(',', '.'),
        )
        if (Number.isNaN(checkNaN)) {
          values.taxReduction = parseNumber(values.taxReduction)
        } else {
          values.taxReduction = checkNaN
        }
      }

      // if (
      //   !values?.totalAfterTaxVnese &&
      //   values?.totalAfterTax == 0 &&
      //   partsName.includes('dieu-chinh')
      // ) {
      //   values.totalAfterTaxVnese = Utils.changeVneseAdjustInvoice(
      //     values?.totalAfterTaxVnese,
      //     values?.totalAfterTax ?? 0,
      //     currency?.readMoneyInvoice,
      //   )
      // }
      const formCategory = values?.serial?.slice(0, 1)
      if (formCategory == 3) {
        let validateSubmit = false
        if (!values?.customerCompanyName) {
          ToastHelper.showError(
            'Tên (Đơn vị bán tài sản NN) không thể để trống',
          )
          validateSubmit = true
        } else {
          if (values?.customerCompanyName?.trim()?.length > 400) {
            ToastHelper.showError(
              `Tên (Đơn vị bán tài sản NN) có độ dài không vượt quá 400 ký tự`,
            )
            validateSubmit = true
          }
        }
        if (!values?.customerFullAddress) {
          ToastHelper.showError(
            'Địa chỉ (Đơn vị bán tài sản NN) không thể để trống',
          )
          validateSubmit = true
        } else {
          if (values?.customerFullAddress?.trim()?.length > 400) {
            ToastHelper.showError(
              `Địa chỉ (Đơn vị bán tài sản NN) có độ dài không vượt quá 400 ký tự`,
            )
            validateSubmit = true
          }
        }
        if (validateSubmit) return
      }
      if (!values.invoiceTemplateId) {
        ToastHelper.showError('Chưa chọn ký hiệu hóa đơn')
        return
      }
      // Nếu là hóa đơn máy tính tiền
      // if (isFromPOS)
      //   values = _.omit(values, ['customerAccountNumber', 'customerBankName'])
      //Check thông tin người mua
      if (
        values.customerCompanyName === '' &&
        values.customerName === '' &&
        !isDeliveryBill
      ) {
        ToastHelper.showError(
          'Vui lòng nhập tên người mua hàng hoặc tên đơn vị',
        )
        resetButtonSaveAndSign()
        return
      }
      // Có MST người mua
      if (values.customerTaxCode !== '') {
        if (
          !regexTaxCode(values.customerTaxCode) &&
          !REGEX_CMND_CCCD.test(values.customerTaxCode)
        ) {
          ToastHelper.showError(
            'Mã số thuế hoặc căn cước công dân không hợp lệ',
          )
          resetButtonSaveAndSign()
          return
        }
        if (values.customerCompanyName === '') {
          ToastHelper.showError('Vui lòng nhập tên đơn vị')
          resetButtonSaveAndSign()
          return
        } else if (values.customerFullAddress === '') {
          ToastHelper.showError('Vui lòng nhập địa chỉ khách hàng')
          resetButtonSaveAndSign()
          return
        }
      }
      // Bỏ phần kiểm tra tổng tiền (19/08/2024)
      // Có kiểm tra tổng tiền và tổng tiền bằng chữ
      // if (
      //   (!values.totalAfterTax || !values.totalAfterTaxVnese) &&
      //   !partsName.includes('dieu-chinh') &&
      //   !partsName.includes('dieu-chinh-khac-he-thong') &&
      //   values.type !== INVOICE_TYPE.ADJUST &&
      //   isProduct
      // ) {
      //   ToastHelper.showError(
      //     'Thiếu tổng tiền hoặc tổng tiền không được xác thực',
      //   )
      //   resetButtonSaveAndSign()
      //   return
      // }

      //huy
      if (tableData[0].name === '') {
        ToastHelper.showError('Vui lòng nhập thông tin Hàng hoá/ Dịch vụ')
        resetButtonSaveAndSign()
        if (submitAction == 'SaveNoNavigate') {
          setShowModalConfirmSaveToSendInvoice(false)
        }
        return
      }
      // item cuối không có tên nhưng có tiền
      if (
        tableData[tableData.length - 1].totalUnitPrice &&
        !tableData[tableData.length - 1].name
      ) {
        ToastHelper.showError('Vui lòng nhập thông tin Hàng hoá/ Dịch vụ')
        resetButtonSaveAndSign()
        if (submitAction == 'SaveNoNavigate') {
          setShowModalConfirmSaveToSendInvoice(false)
        }
        return
      }

      // Delivery bill validations
      if (isDeliveryBill) {
        if (!values.deliveryOrderDate) {
          values.deliveryOrderDate = dayjs()
        }
        const requiredFilelds = [
          {
            name: 'buyerName',
            label:
              values.invoiceType == 'N'
                ? 'lệnh điều đồng'
                : 'hợp đồng kinh tế số',
            ofType: ['N', 'B'],
          },
          {
            name: 'deliveryOrderDate',
            label: 'ngày',
            ofType: ['N', 'B'],
          },
          {
            name: 'addressWarehouse',
            label: 'Địa chỉ kho xuất hàng',
            ofType: ['N'],
          },
          {
            name: 'consigneeUnitAddress',
            label: 'Địa điểm nhận hàng',
            ofType: ['N'],
          },
          {
            name: 'deliveryBy',
            label: 'tên người vận chuyển',
            ofType: ['B'],
          },
          {
            name: 'transportationMethod',
            label: 'phương tiện vận chuyển',
            ofType: ['N', 'B'],
          },
          {
            name: 'toWarehouseName',
            label: 'trường thông tin Nhập tại kho',
            ofType: ['B'],
          },
          {
            name: 'fromWarehouseName',
            label: 'trường thông tin Xuất tại kho',
            ofType: ['B'],
          },
        ]
        let errFields = []
        requiredFilelds.map((field) => {
          if (
            !values[field.name] &&
            field.ofType.includes(formik.values.invoiceType)
          ) {
            ToastHelper.showError(`Vui lòng nhập ${field.label}`)
            resetButtonSaveAndSign()
            errFields.push(field.name)
          }
        })
        if (errFields.length > 0) return
        if (values.consigneeUnitTaxcode || values.buyerTaxCode) {
          if (
            !regexTaxCode(values.consigneeUnitTaxcode || values.buyerTaxCode) &&
            !REGEX_CMND_CCCD.test(
              values.consigneeUnitTaxcode || values.buyerTaxCode,
            )
          ) {
            ToastHelper.showError(
              'Mã số thuế hoặc căn cước công dân không hợp lệ',
            )
            resetButtonSaveAndSign()
            return
          }
        }
      }

      // nghị định 70
      // Số căn cước công dân/CMND
      if (formik.customerPersonalIdentificationNumber) {
        if (
          !REGEX_CMND_CCCD.test(formik.customerPersonalIdentificationNumber)
        ) {
          ToastHelper.showError('Số CCCD/CMND không hợp lệ')
          resetButtonSaveAndSign()
          return
        }
      }
      // số hộ chiếu
      if (formik.customerPassportNumber) {
        if (
          !REGEX_IDENTIFY.REGEX_PASSPORT.test(formik.customerPassportNumber)
        ) {
          ToastHelper.showError('Số hộ chiếu không hợp lệ')
          resetButtonSaveAndSign()
          return
        }
      }
      // mã đơn vị quan hệ ngân sách
      if (formik.budgetUnitCode) {
        if (!REGEX_BUDGET_UNIT_CODE.test(formik.budgetUnitCode)) {
          ToastHelper.showError('Mã đơn vị quan hệ ngân sách không hợp lệ')
          resetButtonSaveAndSign()
          return
        }
      }
      // end nghị định 70

      let _buyerInfoExtendFields = buyerInfoExtendFields
        .filter(({ forceShow, show }) => forceShow || show)
        .map((item) => ({
          ...item,
          value: values.extendFields[item.name],
        }))

      let _tableDetailExtendFields = tableDetailExtendFields.filter(
        ({ forceShow, show }) => forceShow || show,
      )
      let tempCurrentIndex = 0
      let checkSpecialIsInValid = false,
        checkMotorSaleTemplate = false
      let _tableData = tableData.map((item) => {
        // Nếu là ghi chú diễn giải thì gán lại thực nhập thực xuất
        if (item.actualExport === '') item.actualExport = null
        if (item.actualImport === '') item.actualImport = null
        let extend_fields = _tableDetailExtendFields.map(
          ({ fieldId, name }) => ({
            fieldId,
            name,
            invoice_product_extend_field: {
              value: item[name]?.value ?? item[name]?.defaultValue,
            },
          }),
        )
        // lấy code phía dưới tối ưu vòng lặp
        item.stt =
          (item.type !== 4 || _.isEmpty(item.name)
            ? ++tempCurrentIndex
            : null) || item.stt
        item.discountMoney =
          (formik.values.discountType === 0 ? null : item.discountMoney) ||
          item.discountMoney
        item.discount =
          (formik.values.discountType === 0 ? null : item.discount) ||
          item.discount
        if (item?.type === PRODUCT_PROPERTY.SPECIAL_GOODS) {
          if (!item?.plateNumber && currentTemplate?.isDeliveryInvoice)
            checkSpecialIsInValid = true
          if (
            (!item?.chassisNumber || !item?.engineNumber) &&
            currentTemplate?.category?.code === 'BX'
          )
            checkMotorSaleTemplate = true
        }
        return { ...item, extend_fields }
      })
      if (checkSpecialIsInValid) {
        ToastHelper.showError(
          'Vui lòng nhập Biển kiểm soát cho các dòng có tính chất HHDV đặc trưng',
        )
        resetButtonSaveAndSign()
        return
      }
      if (checkMotorSaleTemplate) {
        ToastHelper.showError(
          'Vui lòng nhập Số khung hoặc Số máy cho các dòng bán xe mô tô, xe gắn máy',
        )
        resetButtonSaveAndSign()
        return
      }
      //end huy
      values.discount = Utils.parseFormattedNumberToFloat(values.discount)
      if (
        partsName.includes('dieu-chinh') ||
        partsName.includes('dieu-chinh-khac-he-thong') ||
        values.type === INVOICE_TYPE.ADJUST ||
        !values.autoCalculate
      ) {
        values.total = Utils.parseFormattedNumberToFloat(values.total)
        values.totalAfterTax = Utils.parseFormattedNumberToFloat(
          values.totalAfterTax,
        )
        values.taxMoney = Utils.parseFormattedNumberToFloat(values.taxMoney)
      }
      if (typeof values.exchangeRate === 'string') {
        values.exchangeRate = Utils.parseFormattedNumberToFloat(
          values.exchangeRate,
        )
      }
      // hotfix
      if (!['VND', 'VNĐ'].includes(values.currency) && !values.exchangeRate) {
        ToastHelper.showError(`Tỷ giá chuyển đổi không hợp lệ`)
        return
      }

      switch (actionType) {
        case ACTION_TYPE.CREATE: {
          break
        }
        case ACTION_TYPE.REPLACE:
        case ACTION_TYPE.ADJUST: {
          values.type = actionType == ACTION_TYPE.ADJUST ? 2 : 1

          let externalInvoiceId
          if (
            partsName.includes('dieu-chinh-khac-he-thong') ||
            partsName.includes('thay-the-khac-he-thong')
          ) {
            try {
              let resCheck = await invoiceApi.checkExternal(fetchedInvoiceInfo)
              if (resCheck.data == true) {
                const res = await invoiceApi.bulkCreateExternal({
                  invoices: [fetchedInvoiceInfo],
                })

                externalInvoiceId = res?.data?.createInvoiceIds?.at(0)
              } else {
                externalInvoiceId = resCheck.data
              }
            } catch (err) {
              console.log(err)
              return
            } finally {
              resetButtonSaveAndSign()
            }
          }

          values.originalInvoiceId = externalInvoiceId ?? invoiceId
          values.Original =
            partsName.includes('dieu-chinh-khac-he-thong') ||
            partsName.includes('thay-the-khac-he-thong')
              ? fetchedInvoiceInfo
              : invoiceData

          break
        }
        case ACTION_TYPE.UPDATE: {
          const result =
            values?.totalAfterTax == 0
              ? await handle_warning_total()
              : { isConfirmed: true }
          if (result.isConfirmed) {
            updateInvoice(
              values,
              submitAction,
              _tableData,
              company,
              dispatch,
              setAppSpinning,
              invoiceId,
              _buyerInfoExtendFields,
              navigate,
              isFromPOS,
              isDeliveryBill,
              (invoiceId) => {
                setIssueInvoiceFromPosModalInfo({ show: true, invoiceId })
              },
              (invoiceId) => {
                setSendDraftInvoiceModalShow(true)
              },
              resetButtonSaveAndSign(),
            )
            return
          } else {
            resetButtonSaveAndSign()
            return
          }
        }
        default:
          return
      }

      let signingConfig = {
        signingMethod: company?.activeSigningMethod,
      }

      const result =
        values?.totalAfterTax == 0
          ? await handle_warning_total()
          : { isConfirmed: true }
      if (result.isConfirmed) {
        let invoice = await createNewInvoice(
          values,
          submitAction,
          _tableData,
          company,
          dispatch,
          setAppSpinning,
          navigate,
          _buyerInfoExtendFields,
          signingConfig,
          () => {
            setShowModalConfirmSaveToSendInvoice(false)
            setSendDraftInvoiceModalShow(true)
          },
          () => {
            setShowModalConfirmSaveToSendInvoice(false)
          },
          isFromPOS,
          isDeliveryBill,
          (invoiceId) =>
            setIssueInvoiceFromPosModalInfo({ show: true, invoiceId }),
          resetButtonSaveAndSign,
        )
        if (invoice?.invoiceId) {
          setCreatedInvoiceId(invoice.invoiceId)
        }
      }
      resetButtonSaveAndSign()
      return
    },
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
  })

  useEffect(() => {
    formik.setFieldValue('startFormData', 0)
  }, [])

  // hàm thay đổi kí hiệu hóa đơn
  const handleSelectInvoiceSerial = useCallback(
    (selectedInvoiceTemplate) => {
      const { invoiceTemplateId, serial } = selectedInvoiceTemplate || {}
      formik.setFieldValue('invoiceTemplateId', invoiceTemplateId)
      formik.setFieldValue('serial', serial)
      formik.setFieldValue('invoiceTemplateName', selectedInvoiceTemplate?.name)
      const category = selectedInvoiceTemplate?.category
      if (category) {
        // chỉ 1 thuế suất
        formik.setFieldValue(
          'multipleTaxRate',
          selectedInvoiceTemplate?.category?.taxType === 2,
        )
        formik.setFieldValue(
          'taxType',
          selectedInvoiceTemplate?.category?.taxType,
        )

        if (category?.code == 'BV') {
          formik.setFieldValue('advanceAmount', 0)
          formik.setFieldValue('patientExemptedAmount', 0)
          formik.setFieldValue('hospitalReturnAmount', 0)
          formik.setFieldValue('patientPaidAdditionalAmount', 0)
          formik.setFieldValue('totalPayableAmount', 0)
          formik.setFieldValue('healthInsuranceCoveredAmount', 0)
          formik.setFieldValue('coronavirusPcrTestCost', 0)
          formik.setFieldValue('covid19TreatmentCost', 0)
        } else {
          formik.setFieldValue('advanceAmount', '')
          formik.setFieldValue('patientExemptedAmount', '')
          formik.setFieldValue('hospitalReturnAmount', '')
          formik.setFieldValue('patientPaidAdditionalAmount', '')
        }
      }
      formik.setFieldValue('isTaxReduction', false)
      const taxRate = serial?.charAt(0) == '2' ? 0 : systemTaxRate

      formik.setFieldValue('taxRate', taxRate)
      formik.setFieldValue('discount', 0)
      // setTemplateInvoiceSerials()
      setTableData([
        {
          no: 1,
          type:
            selectedInvoiceTemplate?.isDeliveryInvoice ||
            selectedInvoiceTemplate?.category?.code === 'BX'
              ? PRODUCT_PROPERTY.SPECIAL_GOODS
              : PRODUCT_PROPERTY.GOODS_SERVICE,
          name: '',
          unit: '',
          unitPrice: 0,
          quantity: 0,
          discount: 0,
          totalUnitPrice: 0,
          unitPriceAfterTax: 0,
          totalUnitPriceAfterTax: 0,
          taxRate: taxRate ?? '0',
          taxReduction: 0,
          taxReductionRate: 0,
          taxMoney: 0,
          discountMoney: 0,
          productId: 0,
          ...(selectedInvoiceTemplate?.isDeliveryInvoice
            ? { plateNumber: '' }
            : {}),
        },
      ])
      formik.setFieldValue('invoiceType', selectedInvoiceTemplate?.type)
      setCurrentTemplate(selectedInvoiceTemplate)
      if (
        selectedInvoiceTemplate?.isDeliveryInvoice ||
        selectedInvoiceTemplate?.category?.code === 'BX'
      ) {
        setCheckedHHDV(true)
      }
    },
    [formik, setTableData, systemTaxRate],
  )

  const roundingConfig = useCallback(
    (defaultConfig) => {
      if (!formatNumber) return null
      return ['VNĐ', 'VND'].includes(formik.values.currency)
        ? formatNumber[defaultConfig]
        : formatNumber.exchangeTotalCost
    },
    [formatNumber, formik.values.currency],
  )

  let isAdjustInvoice = false
  isAdjustInvoice = useMemo(() => {
    if (
      partsName.includes('dieu-chinh') ||
      partsName.includes('dieu-chinh-khac-he-thong') ||
      (partsName.includes('cap-nhat') &&
        formik.values.type === INVOICE_TYPE.ADJUST)
    ) {
      return true
    } else {
      return false
    }
  }, [formik.values.type, partsName])

  const {
    fetchInvoiceData,
    fetchExtendFields,
    fetchLatestInvoice,
    fetchLatestInvoiceTemplate,
    fetchTemplateSerial,
  } = useFetchInvoice({
    redirectUrl,
    setInvoiceData,
    setTableDetailExtendFields,
    setBuyerInfoExtendFields,
    setLatestInvoice,
    setInvoiceType,
    setLatestInvoiceTemplate,
    setTemplateInvoiceSerials,
    setInvoiceTemplateDetail,
    isFromPOS,
    isDeliveryBill,
  })

  const { calculateAndSetFinalMoney, calculateAndSetExchangedMoneyPerItem } =
    useInvoiceCalculations({
      formik,
      actionType,
      setIsChangeTable,
      isChangeTaxRate,
      isChangeTable,
      roundingConfig,
      tableData,
      setTableData,
    })

  const {
    onCheckTaxReduction,
    onChangeCheckHHDV,
    onChangePayment,
    onToggleMulTaxRate,

    onChangeTableData,
    onChangeGTGT,
    onSelectDiscountType,

    handleAddRow,
    handleChangeProductNameTableData,
    onSelectProduct,
  } = useInvoiceActions({
    formik,
    tableData,
    setTableData,
    setCheckedHHDV,
    roundingConfig,
    isDeliveryBill,
    invoiceType,
    showPriceAfterTax,
    setIsChangeTable,
    isAdjustInvoice,
    persistent,
    systemTaxRate,
  })

  useEffect(() => {
    const fetchingResources = async () => {
      try {
        unwrapResult(
          dispatch(thunkGetGoodsGroupList(Global.gFiltersGoodsGroupList)),
        )
        unwrapResult(dispatch(thunkGetGoodsList()))
      } catch (error) {
        console.error(error)
      }
    }
    fetchingResources()
  }, [dispatch])

  useEffect(() => {
    dispatch(thunkGetMoneyTypeList(Global.gFiltersMoneyTypeList))
    fetchTemplateSerial()

    // huy
    fetchExtendFields()
    // // lay ten hang hoa
    // setStateGoods(row?.name ? optionsGoods.find((option) => option.value === row?.name)
    //   : null)
  }, [])

  useEffect(() => {
    if (partsName.includes('them-moi') && !invoiceId) {
      setTableData([{ ...tableData[0], taxRate: systemTaxRate }])
    }
  }, [systemTaxRate, invoiceId])

  useEffect(() => {
    if (partsName.includes('them-moi') && !invoiceId) {
      fetchLatestInvoice()
    }
    if (invoiceId) {
      fetchInvoiceData(invoiceId).then((data) => {
        if (data) {
          const { invoiceProduct, extend_fields, ...restInvoiceInfo } = data
          if (data.type === INVOICE_TYPE.ADJUST) {
            formik.setFieldValue('autoCalculate', false)
          }
          if (
            partsName.includes('dieu-chinh') ||
            partsName.includes('dieu-chinh-khac-he-thong')
          ) {
            console.log('dsdsdshjskhddata.invoiceProduct', data.invoiceProduct)
            if (
              getParam('viewInvoiceProduct') &&
              partsName.includes('dieu-chinh')
            ) {
              data &&
                data.invoiceProduct &&
                setTableData([
                  ...data.invoiceProduct.map((product) => {
                    if (product.extend_fields?.length) {
                      for (let field of product.extend_fields) {
                        product[field?.name] = {
                          value: field?.invoice_product_extend_field?.value,
                        }
                      }
                    }
                    console.log('product', product)
                    return product
                  }),
                ])
            } else {
              data &&
                data?.invoiceProduct &&
                setTableData([
                  {
                    no: 1,
                    type: 1,
                    name: '',
                    unit: '',
                    unitPrice: 0,
                    quantity: 0,
                    discount: 0,
                    totalUnitPrice: 0,
                    taxRate: data?.taxRate,
                    taxMoney: 0,
                    taxReduction: 0,
                    taxReductionRate: 0,
                    discountMoney: 0,
                    productId: 0,
                    totalAfterTaxVnese: partsName.includes('dieu-chinh')
                      ? 'Tăng không đồng'
                      : '',
                  },
                ])
            }
          } else {
            data &&
              data.invoiceProduct &&
              setTableData([
                ...data.invoiceProduct.map((product) => {
                  if (product.extend_fields?.length) {
                    for (let field of product.extend_fields) {
                      product[field?.name] = {
                        value: field?.invoice_product_extend_field?.value,
                      }
                    }
                  }

                  return product
                }),
              ])
          }
          setFetchedInvoiceInfo(restInvoiceInfo)
          setInvoiceType(data.invoice_template?.type)
          setInvoiceExtendFields(extend_fields)
        }
      })
    }
  }, [invoiceId])

  useEffect(() => {
    if (!invoiceInfo) return

    setFetchedInvoiceInfo(
      invoiceInfo.split('&').reduce(
        (result, item) => ({
          ...result,
          [item.split('=')[0]]: item.split('=')[1],
        }),
        { type: 0 },
      ),
    )
  }, [invoiceInfo])

  useEffect(() => {
    if (
      isAdjustInvoice
        ? formik.values.autoCalculate && formik.values.taxRate === 'KHAC'
        : formik.values.taxRate === 'KHAC' || !formik.values.autoCalculate
          ? true
          : false
    ) {
      let taxMoney = Utils.parseFormattedNumberToFloat(formik.values.taxMoney)
      let total = Utils.parseFormattedNumberToFloat(formik.values.total)
      console.log('totaltotal2', total)
      let totalAfterTax = total + taxMoney
      formik.setFieldValue('taxMoney', taxMoney)
      formik.setFieldValue('totalAfterTax', totalAfterTax)
    } else {
      let taxMoney = Utils.parseFormattedNumberToFloat(formik.values.taxMoney)
      formik.setFieldValue('taxMoney', taxMoney)
    }
  }, [formik.values.taxMoney])

  useEffect(() => {
    //check truong hop dac biet vi chua biet loi o dau
    if (
      formik.values.autoCalculate &&
      formik?.values?.total == fetchedInvoiceInfo?.total &&
      tableData?.length == 1 &&
      tableData?.[0]?.unitPrice == 0
    ) {
      console.log('thdb')
      formik.setFieldValue('total', 0)
      formik.setFieldValue('exchangedTotal', 0)
      formik.setFieldValue('taxMoney', 0)
      formik.setFieldValue('exchangedTaxMoney', 0)
    }
    if (!formik.values.autoCalculate) {
      let taxMoney = Utils.parseFormattedNumberToFloat(formik.values.taxMoney)
      let total = Utils.parseFormattedNumberToFloat(formik.values.total)
      let totalAfterTax = total + taxMoney
      formik.setFieldValue('total', total)
      formik.setFieldValue('totalAfterTax', totalAfterTax)
    }
  }, [formik.values.total])

  // Tính toán và set lại giá trị cho tổng tiền và tổng tiền thanh toán
  useEffect(() => {
    console.log('dsds')
    console.log('startFormData', formik.values?.startFormData)
    console.log(partsName.includes('cap-nhat'))
    console.log('totalAfterTax', formik.values.totalAfterTax)
    console.log('fetchedInvoiceInfo', fetchedInvoiceInfo)
    let totalAfterTax = formik.values.totalAfterTax || 0
    if (
      !formik.values.autoCalculate &&
      // [1, 2].includes(fetchedInvoiceInfo?.type) &&
      (partsName.includes('cap-nhat') || partsName.includes('them-moi')) &&
      !formik.values?.startFormData
    ) {
      let totalAfterTaxTemp = fetchedInvoiceInfo?.totalAfterTax
      if (totalAfterTaxTemp) {
        totalAfterTax = totalAfterTaxTemp
        formik.setFieldValue('startFormData', 1)
      }
      console.log('totalAfterTaxTemp1', totalAfterTaxTemp)
    } else {
      if (!formik.values?.startFormData) {
        let totalAfterTaxTemp = fetchedInvoiceInfo?.totalAfterTax
        if (totalAfterTaxTemp) {
          totalAfterTax = totalAfterTaxTemp
          formik.setFieldValue('startFormData', 1)
        }
        // formik.setFieldValue('startFormData', 1)
      } else {
        totalAfterTax = Utils.parseFormattedNumberToFloat(totalAfterTax) || 0
        console.log('totalAfterTax1', totalAfterTax)
        // formik.setFieldValue('startFormData', 1)
        // if (typeof totalAfterTax === 'string' || !formik.values.autoCalculate) {
        //   totalAfterTax = Utils.parseFormattedNumberToFloat(totalAfterTax) || 0
        //   console.log('totalAfterTax1', totalAfterTax)
        //   formik.setFieldValue('startFormData', 1)
        // }
        // else if (
        //   formik.values.autoCalculate &&
        //   fetchedInvoiceInfo?.totalAfterTax &&
        //   !formik.values?.startFormData
        // ) {
        //   totalAfterTax = fetchedInvoiceInfo?.totalAfterTax || 0
        //   formik.setFieldValue('startFormData', 1)
        //   console.log('totalAfterTax2', totalAfterTax)
        // }
      }
    }

    let prefix, endSymbol, afterdecimal, unit, separation
    if (formik.values.currency === 'VNĐ' || formik.values.currency === 'VND') {
      prefix = ''
      endSymbol = ''
      unit = currencies.find(
        (option) => option.value === formik.values.currency,
      )?.name
      afterdecimal = ''
      separation = 'phẩy'
    } else {
      unit = currencies.find(
        (option) => option.code === formik.values.currency,
      )?.VNUnit
      prefix = currencies.find(
        (option) => option.code === formik.values.currency,
      )?.VNPrefix
      endSymbol = currencies.find(
        (option) => option.code === formik.values.currency,
      )?.VNEndSymbol
      afterdecimal = currencies.find(
        (option) => option.code === formik.values.currency,
      )?.VNAfterDecimal
      separation = currencies.find(
        (option) => option.code === formik.values.currency,
      )?.VNSeperation
    }
    let totalAfterTaxVnese = Utils.numberToWords(
      Utils.formatNumberWithSeparators(totalAfterTax), //num
      'vi', // unit
      prefix ?? '', // prefix
      unit, //unit
      separation, // separation
      endSymbol, // endSymbol
      afterdecimal, // afterdecimal
      currency?.zeroInten,
      currency?.zeroInThousand,
      currency?.evenDisplay,
      formik.values.currency,
      totalAfterTax,
      formatNumber,
    )
    console.log('totalAfterTaxVnese', totalAfterTaxVnese)
    if (isAdjustInvoice) {
      let totalAfterTaxVneseTemp = Utils.changeVneseAdjustInvoice(
        totalAfterTaxVnese,
        totalAfterTax,
        currency?.readMoneyInvoice,
      )
      if (totalAfterTaxVneseTemp) {
        totalAfterTaxVnese = totalAfterTaxVneseTemp
      }
      console.log('totalAfterTaxVneseTemp', totalAfterTaxVneseTemp)
    }
    formik.setFieldValue('totalAfterTax', totalAfterTax)
    formik.setFieldValue(
      'exchangedTotalAfterTax',
      Utils.roundNumber(
        totalAfterTax * (formatNumberData(formik?.values?.exchangeRate) ?? 0),
        formatNumber?.exchangedDiscountMoney,
      ),
    )
    formik.setFieldValue('totalAfterTaxVnese', totalAfterTaxVnese)
    if (partsName.includes('them-moi') && !invoiceId) {
      formik.setFieldValue('startFormData', 1)
    }
  }, [
    formik.values.totalAfterTax,
    isAdjustInvoice,
    formik.values.currency,
    tableData,
    fetchedInvoiceInfo,
  ])

  // gán lại giá trị cho tổng tiền quy đổi và tổng tiền thanh toán quy đổi
  useEffect(() => {
    const fields = [
      'exchangedTotal',
      'exchangedTotalAfterTax',
      'exchangedTaxMoney',
    ]
    fields.forEach((field) => {
      if (
        typeof formik.values[field] === 'string' ||
        !formik.values.autoCalculate
      ) {
        formik.setFieldValue(
          field,
          Utils.parseFormattedNumberToFloat(formik.values[field]),
        )
      }
    })
    // eslint-disable-next-line
  }, [
    formik.values.autoCalculate,
    formik.values.exchangedTotal,
    formik.values.exchangedTotalAfterTax,
    formik.values.exchangedTaxMoney,
  ])

  useEffect(() => {
    let invoiceTemplateId = formik.values.invoiceTemplateId
    if (invoiceTemplateId && invoiceExtendFields) {
      setBuyerInfoExtendFields((old) =>
        old.map(({ invoice_templates, ...rest }) => ({
          ...rest,
          invoice_templates,
          show: !!invoice_templates?.find(
            (item) => item.invoiceTemplateId == invoiceTemplateId,
          )?.invoice_template_extend_field?.active,
          forceShow: !!invoice_templates?.find(
            (item) => item.invoiceTemplateId == invoiceTemplateId,
          )?.invoice_template_extend_field?.forceActive,
          value: invoiceExtendFields?.find(
            ({ fieldId }) => fieldId == rest.fieldId,
          )?.invoice_extend_field?.value,
        })),
      )
      setTableDetailExtendFields((old) =>
        old.map(({ invoice_templates, ...rest }) => ({
          ...rest,
          invoice_templates,
          show: !!invoice_templates?.find(
            (item) => item.invoiceTemplateId == invoiceTemplateId,
          )?.invoice_template_extend_field?.active,
          forceShow: !!invoice_templates?.find(
            (item) => item.invoiceTemplateId == invoiceTemplateId,
          )?.invoice_template_extend_field?.forceActive,
        })),
      )
      // lấy hoá đơn phát hành mới nhất của mẫu
    }
    invoiceTemplateId && fetchLatestInvoiceTemplate(invoiceTemplateId)
  }, [formik.values.invoiceTemplateId, invoiceExtendFields])

  useEffect(() => {
    if (buyerInfoExtendFields?.length) {
      let addonsFields = buyerInfoExtendFields
        .filter(({ forceShow, show }) => forceShow || show)
        .reduce(
          (result, field) => ({
            ...result,
            [field.name]: field.value ?? field.defaultValue ?? undefined,
          }),
          {},
        )
      for (let [key, value] of Object.entries(addonsFields)) {
        let originValue =
          formik.values &&
          formik.values.extendFields &&
          formik.values.extendFields[key]
        if (originValue == undefined) {
          formik.setFieldValue(`extendFields.${key}`, value)
        }
      }
    }
  }, [buyerInfoExtendFields])

  useEffect(() => {
    if (tableDetailExtendFields?.length) {
      let addonsFields = tableDetailExtendFields
        .filter(({ forceShow, show }) => forceShow || show)
        .reduce(
          (result, field) => ({
            ...result,
            [field.name]: field.defaultValue || undefined,
          }),
          {},
        )
      setTableData((oldTb) =>
        oldTb.map((row) => {
          let returnValue = { ...row }
          for (let _key in addonsFields) {
            returnValue[_key] = returnValue[_key] ?? {}
            returnValue[_key] = {
              ...returnValue[_key],
              defaultValue: addonsFields[_key],
            }
          }

          return returnValue
        }),
      )
    }
  }, [tableDetailExtendFields])

  useEffect(() => {
    if (formik.values.multipleTaxRate) {
      // formik.setFieldValue('taxRate', '0')
      setDiscountTypeArray(SelectOptions.discountTypeMultipleTaxRate)
      if (formik.values.discountType === 2) {
        // neu laf chiet khau theo tong gia tri rs ve 0
        formik.setFieldValue('discountType', 0)
        let newTableData = [...tableData]
        newTableData.forEach((item) => {
          item.discount = 0
          item.discountMoney = 0
        })
      }
    } else {
      setDiscountTypeArray(SelectOptions.discountType)
    }
  }, [formik.values.multipleTaxRate])

  useEffect(() => {
    if (formik.values.discountType !== 2) {
      formik.values.discount = null
    }
    if (!formik.values.autoCalculate || formik.values.type === undefined) {
      return
    } else {
      if (formik.values?.startFormData) calculateAndSetFinalMoney(tableData)
    }
  }, [
    formik.values.taxType,
    formik.values.taxRate,
    tableData,
    formik.values.discountType,
    isChangeTaxRate,
    // formik.values.exchangeRate,
  ])

  useEffect(() => {
    const tempArr = moneyTypes.map((item) => {
      return { ...item, value: item?.code, label: item?.code }
    })
    // lay dnah sach tempArr khong chua currencies
    let newCurrencies = tempArr.filter(
      (item) =>
        !currencies.map((_item) => _item.code).includes(item.code) &&
        item.status === 'ACTIVE',
    )
    // tempArr[0] &&
    //   currencies.filter((item) => item.code === tempArr[0].code).length === 0 &&
    setCurrencies([...currencies, ...newCurrencies])
  }, [moneyTypes])

  useEffect(() => {
    let newTableData = [...tableData]
    const discount = Utils.parseFormattedNumberToFloat(formik.values.discount)
    const taxRate = Utils.parseFormattedNumberToFloat(formik.values.taxRate)
    if (formik.values.discountType === 2) {
      newTableData.forEach((item) => {
        item.discount = discount
        item.discountMoney = (item.totalUnitPrice * discount) / 100
        item.taxMoney =
          ((item.totalUnitPrice - item.discountMoney) * taxRate) / 100
      })
    }

    setTableData(newTableData)
  }, [formik.values.discount])

  useEffect(() => {
    let newTableData = [...tableData]

    if (!formik.values.isTaxReduction) {
      newTableData.forEach((item) => {
        item.taxReductionRate = 0
        item.taxReduction = Utils.roundNumber(
          0,
          !['VNĐ', 'VND'].includes(formik.values.currency)
            ? formatNumber?.foreignCurrency
            : formatNumber.currencyExchange,
        )
        item.taxReductionExchange = Utils.roundNumber(
          0,
          !['VNĐ', 'VND'].includes(formik.values.currency)
            ? formatNumber?.foreignCurrency
            : formatNumber.currencyExchange,
        )
      })
    }
    if (formik.values.isTaxReduction) {
      newTableData.forEach((item) => {
        let taxReductionRate = item.taxReductionRate ? item.taxReductionRate : 1
        item.taxReductionRate = taxReductionRate
        let taxReduction =
          ((item.totalUnitPrice - item.discountMoney) * taxReductionRate) /
            100 /
            5 ?? 0
        item.taxReduction = Utils.roundNumber(
          taxReduction,
          !['VNĐ', 'VND'].includes(formik.values.currency)
            ? formatNumber?.foreignCurrency
            : formatNumber.currencyExchange,
        )
        item.taxReductionExchange = Utils.roundNumber(
          taxReduction * formik.values.exchangeRate,
          !['VNĐ', 'VND'].includes(formik.values.currency)
            ? formatNumber?.foreignCurrency
            : formatNumber.currencyExchange,
        )
      })
    }

    setTableData(newTableData)
  }, [formik.values.isTaxReduction])

  useEffect(() => {
    calculateAndSetExchangedMoneyPerItem()
  }, [formik.values.exchangeRate])

  useEffect(() => {
    if (formik.values.autoCalculate) {
      if (formik.values.validateTableData) {
        for (let i = 0; i < tableData.length; i++) {
          const row = tableData[i]
          if (row?.quantity) {
            onChangeTableData(
              { target: { value: row.quantity } },
              row,
              'quantity',
              'number',
            )
          } else {
            onChangeTableData(
              { target: { value: row.unitPrice } },
              row,
              'unitPrice',
              'number',
            )
          }
        }
        if (formik.values.taxType == 1) {
          onChangeGTGT(formik.values.taxRate)
        }
        formik.setFieldValue('validateTableData', null)
      }
    }
  }, [formik.values.autoCalculate])

  const hasDuplicateValueForKey = (arr, key) => {
    const values = _.map(arr, key)
    const uniqueValues = _.uniq(values)
    return values.length !== uniqueValues.length
  }

  const resetButtonSaveAndSign = () => {
    if (submitAction == 'SaveAndSign') {
      setInforActionSaveAndSign({ disabled: false })
    }
  }
  const displayDate = (date) => {
    const dateObject = new Date(date)

    return (
      <span className="invoice-date">
        {/* {formik.values.date} */}
        Ngày {dateObject.getDate()} tháng {dateObject.getMonth() + 1} năm{' '}
        {dateObject.getFullYear()}
      </span>
    )
  }

  const handleConfirmSaveToSendInvoice = () => {
    submitAction = 'SaveNoNavigate'
    formik.submitForm()
  }

  const handleConfirmSaveDuplicateName = () => {
    formik.submitForm()
  }

  // blur khỏi ô thực xuất
  const handleOnActualExportBlur = useCallback(
    (e, row) => {
      const tableDataClone = [...tableData]
      const rowIndex = row.no - 1
      tableDataClone[rowIndex].actualImport = Utils.parseFormattedNumberToFloat(
        e?.target?.value,
      )
      setTableData(tableDataClone)
    },
    [tableData, setTableData],
  )
  const handleRemoveRow = useCallback(
    (row) => {
      setIsChangeTable(true)
      let newTableData = tableData.filter((item) => item.no !== row.no)

      for (let i = 0; i < newTableData.length; i++) {
        newTableData[i].no = i + 1
      }
      setTableData(newTableData)
    },
    [setIsChangeTable, setTableData, tableData],
  )
  // eslint-disable-next-line

  const handleChangeTypeTableData = useCallback(
    (typeValue, row) => {
      setIsChangeTable(true)
      let newTableData = [...tableData]
      newTableData[row.no - 1].type = typeValue
      if (typeValue === 3) {
        newTableData[row.no - 1]['discount'] = 0
        newTableData[row.no - 1]['discountMoney'] = 0
        newTableData[row.no - 1]['exchangedDiscountMoney'] = 0
      }
      // reset các giá trị về rỗng khi type là diễn giải
      if (typeValue === 4) {
        const ignoreArray = ['no', 'name', 'type']
        for (let field in newTableData[row.no - 1]) {
          if (!ignoreArray.includes(field)) {
            newTableData[row.no - 1][field] = ''
          }
        }
      }
      // need refactor add new row
      if (typeValue != PRODUCT_PROPERTY.SPECIAL_GOODS) {
        newTableData[row.no - 1]['plateNumber'] = undefined
        newTableData[row.no - 1]['chassisNumber'] = undefined
        newTableData[row.no - 1]['engineNumber'] = undefined
      }
      setTableData(newTableData)
    },
    [setIsChangeTable, setTableData, tableData],
  )

  const columns = useMemo(() => {
    /** @type {import('antd/es/table').ColumnProps<any>[]} */
    return getColumns({
      isDeliveryBill,
      formik,
      onSelectProduct,
      handleChangeProductNameTableData,
      onChangeTableData,
      setIsChangeTaxRate,
      persistent,
      checkedHHDV,
      handleChangeTypeTableData,
      setInputValue,
      setPersistent,
      isAdjustInvoice,
      handleOnActualExportBlur,
      invoiceSetting,
      formatNumber,
      tableDetailExtendFields,
      tableData,
      handleAddRow,
      handleRemoveRow,
      currentTemplate,
      invoiceTemplateDetail,
      rowHeight,
      setRowHeight,
    })
  }, [
    isDeliveryBill,
    formik,
    onSelectProduct,
    handleChangeProductNameTableData,
    onChangeTableData,
    setIsChangeTaxRate,
    persistent,
    checkedHHDV,
    handleChangeTypeTableData,
    setInputValue,
    setPersistent,
    isAdjustInvoice,
    handleOnActualExportBlur,
    invoiceSetting,
    formatNumber,
    tableDetailExtendFields,
    tableData,
    handleAddRow,
    handleRemoveRow,
    currentTemplate,
  ])

  return (
    <div className="w-100 h-100 d-flex flex-column ">
      <div className="d-flex align-items-center justify-content-between container-xxl mb-4">
        <label style={{ fontSize: 24, fontWeight: '700', color: 'black' }}>
          {invoiceId ? 'Sửa thông tin hóa đơn' : 'Lập hoá đơn'}
        </label>
        <CreatedInvoiceUnit
          value={formik.values.companyUnitId}
          onSelect={(val) => formik.setFieldValue('companyUnitId', val)}
        />
      </div>

      <div className="container-xxl create-invoice-cover flex-fill">
        <div className="create-invoice card card-custom">
          <div className="d-flex justify-content-center">
            <h4
              className="invoice-title font-weight-boldest"
              style={{
                letterSpacing: '0.5px',
                fontSize: 20,
                fontWeight: '700',
              }}
            >
              {formik.values.invoiceTemplateName}
              {/* HOÁ ĐƠN GIÁ TRỊ GIA TĂNG */}
            </h4>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div
              className="d-flex justify-content-center my-3"
              style={{ width: 'fit-content' }}
            >
              <DatePicker
                className="d-flex justify-content-center"
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                minDate={
                  latestInvoiceTemplate?.date
                    ? new Date(latestInvoiceTemplate?.date)
                    : new Date(dayjs().year(), 0, 1)
                }
                customInput={
                  <div className="d-flex justify-content-center">
                    {displayDate(formik.values.date)}
                  </div>
                }
                // showIcon={true}
                todayButton={<button>Hôm nay</button>}
                // readOnly={screenAction == 'xem'}
                selected={new Date(formik.values.date)}
                disabled={isDeliveryBill && actionType !== 'create'}
                onChange={(date) => {
                  const newDate = dayjs(
                    date,
                    // 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Indochina Time)',
                  ).format('YYYY-MM-DD HH:mm:ss')
                  formik.setFieldValue('date', newDate)
                  // changeRegistrationProperty(
                  //   dayjs(
                  //     date,
                  //     'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Indochina Time)',
                  //   ).format('YYYY-MM-DD HH:mm:ss'),
                  // )
                }}
              />
            </div>
          </div>
          {isDeliveryBill ? (
            <DeliveryGeneralInfo
              formik={formik}
              currentCompany={company}
              buyerInfoExtendFields={buyerInfoExtendFields}
              templateInvoiceSerials={templateInvoiceSerials}
              actionType={actionType}
              originalInvoiceInfo={fetchedInvoiceInfo}
              invoiceTemplateId={latestInvoice?.invoiceTemplateId}
              tableData={tableData}
              setTableData={setTableData}
              isTaxReduction={formik.values.isTaxReduction}
              onCheckTaxReduction={onCheckTaxReduction}
              systemTaxRate={systemTaxRate}
              latestInvoice={latestInvoice}
              invoiceType={formik.values.invoiceType}
              handleSelectInvoiceSerial={handleSelectInvoiceSerial}
            />
          ) : (
            <InvoiceGeneralInfo
              formik={formik}
              currentCompany={company}
              buyerInfoExtendFields={buyerInfoExtendFields}
              templateInvoiceSerials={templateInvoiceSerials}
              actionType={actionType}
              originalInvoiceInfo={
                (actionType == ACTION_TYPE.UPDATE &&
                  fetchedInvoiceInfo?.Original) ||
                fetchedInvoiceInfo
              }
              invoiceTemplateId={latestInvoice?.invoiceTemplateId}
              tableData={tableData}
              setTableData={setTableData}
              isTaxReduction={formik.values.isTaxReduction}
              onCheckTaxReduction={onCheckTaxReduction}
              systemTaxRate={systemTaxRate}
              isFromPOS={isFromPOS}
              setCheckedHHDV={(bool) => setCheckedHHDV(bool)}
              handleSelectInvoiceSerial={handleSelectInvoiceSerial}
              invoiceTemplateIdNewYear={invoiceTemplateIdNewYear}
              setInvoiceTemplateIdNewYear={setInvoiceTemplateIdNewYear}
            />
          )}

          <InvoiceTableGeneralInfo
            formik={formik}
            currencies={currencies}
            discountTypeArray={discountTypeArray}
            handleSelectDiscountType={onSelectDiscountType}
            onChangeCheckHHDV={onChangeCheckHHDV}
            checkedHHDV={checkedHHDV}
            onChangePayment={onChangePayment}
            onToggleMulTaxRate={onToggleMulTaxRate}
            mulTaxRate={formik.values.multipleTaxRate}
            checkedPayment={formik.values.isPayment}
            autoCalculate={formik.values.autoCalculate}
            persistent={persistent}
            setPersistent={setPersistent}
            currency={currency}
            invoiceType={formik.values.invoiceType}
            invoiceTemplateIdNewYear={invoiceTemplateIdNewYear}
            setInvoiceTemplateIdNewYear={setInvoiceTemplateIdNewYear}
          />

          <Table
            dataSource={tableData}
            columns={columns}
            bordered
            checkbox
            pagination={false}
            scroll={{
              x: 1200,
            }}
          />

          <div className="d-flex flex-row justify-content-between align-items-start mt-5">
            <SelectGeneralDiscountAndTaxRate
              formik={formik}
              handleChangeGTGT={onChangeGTGT}
              formatNumber={formatNumber}
            />
            <FinalMoneyDisplay
              formik={formik}
              partsName={partsName}
              autoCalculate={formik.values.autoCalculate}
              isAdjustInvoice={isAdjustInvoice}
              formatNumber={formatNumber}
            />
          </div>

          {templateInvoiceSerials?.find(
            ({ invoiceTemplateId }) =>
              invoiceTemplateId == formik.values.invoiceTemplateId,
          )?.category?.code == 'BV' && <TableHospitalInfo formik={formik} />}
          {/* <div className="d-flex flex-row align-items-center w-100 mt-5">
            <MoneyToTextDisplay formik={formik} />
          </div> */}
        </div>

        <SendInvoiceModal
          invoiceId={invoiceId || createdInvoiceId}
          invoice={formik.values}
          show={sendDraftInvoiceModalShow}
          onHide={() => setSendDraftInvoiceModalShow(false)}
        />

        <ModalConfirm
          show={showModalConfirmSaveToSendInvoice}
          setShow={setShowModalConfirmSaveToSendInvoice}
          header="Xác nhận"
          content="Bạn cần lưu dữ liệu trước khi gửi hóa đơn nháp. Bạn có muốn lưu không?"
          handleConfirm={handleConfirmSaveToSendInvoice}
        />

        <ModalConfirm
          show={showModalConfirmDuplicateName}
          setShow={setShowModalConfirmDuplicateName}
          header="Xác nhận"
          content="Hoá đơn có hàng hoá trùng tên, bạn có muốn tiếp tục không?"
          handleConfirm={handleConfirmSaveDuplicateName}
        />

        <AddCustomFieldModal
          invoiceTemplateId={formik.values.invoiceTemplateId}
          tableDetailExtendFields={tableDetailExtendFields}
          setTableDetailExtendFields={setTableDetailExtendFields}
          buyerInfoExtendFields={buyerInfoExtendFields}
          setBuyerInfoExtendFields={setBuyerInfoExtendFields}
          show={AddCustomFieldModalShow}
          onHide={() => setAddCustomFieldModalShow(false)}
          fetchExtendFields={fetchExtendFields}
        />

        <IssueInvoiceFromPosModal
          invoice={{
            ...formik.values,
            invoiceId: issueInvoiceFromPosModalInfo.invoiceId,
          }}
          onIssueSuccess={() =>
            navigate('/hoa-don-dau-ra/hoa-don/may-tinh-tien/danh-sach-hoa-don')
          }
          show={issueInvoiceFromPosModalInfo.show}
          onHide={() =>
            setIssueInvoiceFromPosModalInfo({ show: false, invoiceId: null })
          }
          onShow={() =>
            setIssueInvoiceFromPosModalInfo((prev) => ({ ...prev, show: true }))
          }
        />
      </div>
      <InvoiceFooter
        ref={invoiceFooterRef}
        buttonAddExtensionField={true}
        buttonCancel={true}
        buttonSendDraftInvoice={true}
        buttonPreview={true}
        buttonCreate={true}
        buttonSaveAndSign={true}
        buttonCreateOnClick={() => {
          submitAction = 'Save'
          // hàng hoá dịch vụ trùng tên thì thông báo
          if (hasDuplicateValueForKey(tableData, 'name')) {
            setShowModalConfirmDuplicateName(true)
            return
          }
          formik.submitForm()
        }}
        buttonSaveAndSignOnClick={() => {
          setInforActionSaveAndSign({ disabled: true })
          submitAction = 'SaveAndSign'

          if (hasDuplicateValueForKey(tableData, 'name')) {
            setShowModalConfirmDuplicateName(true)
            return
          }
          formik.submitForm()
        }}
        buttonAddExtensionFieldOnClick={() => {
          setAddCustomFieldModalShow(!AddCustomFieldModalShow)
        }}
        buttonSendDraftInvoiceOnClick={() => {
          setShowModalConfirmSaveToSendInvoice(true)
        }}
        buttonCancelOnClick={() => {
          navigate(redirectUrl)
        }}
        //huy
        buttonPreviewOnClick={() => {
          submitAction = 'Preview'
          formik.submitForm()
        }}
        inforActionSaveAndSign={inforActionSaveAndSign}
        setInforActionSaveAndSign={setInforActionSaveAndSign}
      />
    </div>
  )
}

export default CreateInvoice
